import { useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import css from "./Notifications.module.css";
import NotificationsPopup from "../Modals/NotificationsPopup/NotificationsPopup.jsx";
import { BsBellFill } from "react-icons/bs";
import useTooltip from "../../utils/useTooltip.jsx";
import Tooltip from "../sharedComponents/Tooltip/Tooltip.jsx";
import NotificationDetailsModal from "../Modals/NotificationDetailsModal/NotificationDetailsModal.jsx";
import {
  selectUnreadCount,
  selectIsPopupOpen,
  selectDetailedNotification,
} from "../../redux/notifications/selectors.js";
import {
  openPopup,
  closePopup,
  clearDetailedNotification,
} from "../../redux/notifications/slice.js";
import { getNotificationsList } from "../../redux/notifications/operations.js";

export default function Notifications() {
  const dispatch = useDispatch();
  const unreadCount = useSelector(selectUnreadCount);
  const isPopupOpen = useSelector(selectIsPopupOpen);
  const detailedNotification = useSelector(selectDetailedNotification);
  const containerRef = useRef(null);

  useEffect(() => {
    if (isPopupOpen) {
      dispatch(getNotificationsList());
    }
  }, [isPopupOpen, dispatch]);

  useEffect(() => {
    if (!isPopupOpen) return;
    const handleClickOutside = e => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        dispatch(closePopup());
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isPopupOpen, dispatch]);

  const {
    tooltipPosition,
    isTooltipVisible,
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
    handleClick,
  } = useTooltip();

  return (
    <div ref={containerRef} className={css.tooltip}>
      <button
        className={css.btn}
        onMouseEnter={handleMouseEnter}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        onClick={() => {
          dispatch(isPopupOpen ? closePopup() : openPopup());
          handleClick();
        }}
      >
        <BsBellFill className={css.icon} />
        {unreadCount > 0 && (
          <span className={css.badge}>
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>

      {isPopupOpen && <NotificationsPopup />}

      <NotificationDetailsModal
        notification={detailedNotification}
        onClose={() => dispatch(clearDetailedNotification())}
      />

      <Tooltip
        isVisible={isTooltipVisible}
        position={tooltipPosition}
        text="Сповіщення"
      />
    </div>
  );
}
